<template>
  <div class="rentalCar">
    <div class="slide-one"></div>
    <div class="content-center" style="padding: 40px 0 80px">
      <div class="title-box">
        <div class="title">协助客户一站式购车</div>
      </div>
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/rentalCar-1.png" alt="" />
            <div class="title">车型多</div>
            <div class="p">40+车型</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/rentalCar-2.png" alt="" />
            <div class="title">包上牌</div>
            <div class="p">提车可上路</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/rentalCar-3.png" alt="" />
            <div class="title">包保险</div>
            <div class="p">出行有保障</div>
          </div></el-col
        >
        <el-col :span="5"
          ><div class="card-square">
            <img src="../assets/rentalCar-4.png" alt="" />
            <div class="title">免费挂靠</div>
            <div class="p">拉货有资质</div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- <div class="slide-two"></div> -->
    <img src="../assets/buyClass.png" alt="" style="width: 100%" />
    <div class="content-center" style="padding: 40px 0 0px">
      <div class="title-box">
        <div class="title">与平台业务协同，为购车司机创收</div>
      </div>
      <div class="slide-three"></div>
    </div>
    <div style="background: #f7f7f8; padding-bottom: 50px">
      <div
        class="content-center"
        style="padding: 80px 0 40px; width: 100%; box-sizing: border-box"
      >
        <div class="title-box">
          <div class="title">爆款车型，任意选择</div>
        </div>
      </div>
      <div class="vehicle-list clearfix" v-cloak>
        <ul>
          <li class="vehicle-item" v-for="item in vehicleList" :key="item.id">
            <img :src="item.images" alt="车辆图" />
            <div class="vehicle-item-content">
              <h2>{{ item.title }}</h2>
              <p class="tags">
                <span v-for="it in item.tags" :key="it">{{ it }}</span>
              </p>
              <ol style="width: 50%">
                <li v-for="(it, id) in item.payPlan" :key="id">
                  <span style="color: #7e8ea5">{{ it.name }}</span
                  ><span>{{ it.value }}</span>
                </li>
              </ol>
              <!-- <p class="desc">{{item.desc}}</p> -->
              <a href="javascript:;" @click.stop="showDialog"
                >马上预约，领取购车礼包</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
        <!-- 弹窗 -->
    <div
      :class="dialogVisible ? 'dialog-wrap-show dialog-wrap' : 'dialog-wrap'"
    >
      <div class="dialog-mask"></div>
      <div class="dialog-form">
        <div class="dialog-close" @click.stop="closeDialog"></div>
        <p>
          <input
            type="text"
            v-model="ruleForm.name"
            placeholder="请问怎么称呼您(可选)"
          />
        </p>
        <p>
          <input
            type="number"
            v-model="ruleForm.mobile"
            :maxlength="11"
            placeholder="请输入手机号码1"
          />
        </p>
        <a
          href="javascript:;"
          style="background-color:#f16622;cursor:pointer;"
          @click.stop="submitForm"
          >立即预约</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data () {
    return {
      vehicleList: [
        {
          id: 1,
          images: require('../assets/car1.png'),
          title: '长安神骐T20平板（平板）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '2174元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '3070元' },
          ],
          desc: '平台同车型的司机平均月收入：9378元（仅供参考）',
        },
        {
          id: 2,
          images: require('../assets/car2.png'),
          title: '长安睿行M80两座（中面）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '2490元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '3516元' },
          ],
          desc: '平台同车型的司机平均月收入：10366元（仅供参考）',
        },
        {
          id: 3,
          images: require('../assets/car3.png'),
          title: '五菱荣光V（小面）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '1996元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '2880元' },
          ],
          desc: '平台同车型的司机平均月收入：8865元（仅供参考）',
        },
        {
          id: 4,
          images: require('../assets/car4.png'),
          title: '上汽依维柯V35（大面）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '4049元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '5841元' },
          ],
          desc: '平台同车型的司机平均月收入：12612元（仅供参考）',
        },
        {
          id: 5,
          images: require('../assets/car5.png'),
          title: '长安睿行M80四座（中面）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '2556元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '3609元' },
          ],
          desc: '平台同车型的司机平均月收入：10366元（仅供参考）',
        },
        {
          id: 6,
          images: require('../assets/car6.png'),
          title: '开瑞优优新能源车（中面）',
          tags: ['首付0元', '最快一天提车', '可分期'],
          payPlan: [
            { name: '还款周期', value: '36期' },
            { name: '月供金额', value: '2800元' },
            { name: '还款周期', value: '24期' },
            { name: '月供金额', value: '4066元' },
          ],
          desc: '平台同车型的司机平均月收入：10539元（仅供参考）',
        }
      ],
      dialogVisible: false,
      ruleForm: {
        name: '',
        mobile: '',
      },
    };
  },
  methods: {
    showDialog () {
      this.dialogVisible = true
    },
    checkMobile () {
      if(!this.ruleForm.mobile){
        this.$message.error('请输入手机号');
        return false;
      }else if (!/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.ruleForm.mobile)) {
        this.$message.error('您的手机号码输入有误！');
        return false
      }
      return true;
    },
    getEnv(){
      if(location.host.indexOf('localhost') > -1 || location.host.indexOf('www-stg') > -1){
        return 'https://oms-stg.huolala.cn'
      }
      if(location.host.indexOf('www-pre') > -1){
        return 'https://oms-pre.huolala.cn'
      }
      if(location.host === 'www.huolalazuche.cn'){
        return 'https://oms.huolala.cn'
      }
    },
    async submitForm () {
      if(!this.checkMobile()){
        return ;
      }
      const { mobile, name } = this.ruleForm;
      const url = this.getEnv()+'/api/sale/scExInter/insertSaleclueForEx.do'
      await axios.get(url,{
        params:{
          comName:'',
          mobile,
          sources: 'hll-buy-car-pc',
          clueFrom: '拉拉买车官网',
          clueFromCode: 'GW-LLMC',
          realName: name
        }
      })
      this.$message.success('您已经预约成功，请耐心等待销售顾问联系哦！');
      this.ruleForm = {
        name: '',
        mobile: '',
      }
      this.closeDialog()
    },
    // 关闭弹窗
    closeDialog () {
      this.dialogVisible = false
    },
  }
};
</script>

<style lang="scss" scoped>
.slide-one {
  height: 520px;
  background: url(../assets/rentCarBanner.png) no-repeat center;
  background-size: auto 100%;
  position: relative;
  .title-warp {
    width: 500px;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translateY(-50%);
  }
  .title {
    font-size: 44px;
    font-weight: 600;
    color: #ffffff;
    line-height: 66px;
  }
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.title-box::before {
  content: "";
  display: block;
  position: absolute;
  background: #f16622;
  width: 85px;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.title-box {
  position: relative;
  text-align: center;
  height: 66px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #2f3439;
    line-height: 66px;
  }
}
.row-bg {
  margin-top: 30px;
}
.card-square:hover {
  box-shadow: 0px 0px 10px 5px #e3e3e3;
}
.card-square {
  text-align: center;
  height: 225px;
  cursor: pointer;
  transition: all 0.5s linear;
  // box-shadow: #e3e3e3 10px 16px 2px -9px;

  img {
    width: 68px;
    height: 68px;
    margin: 40px 0 10px 0;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #2f3439;
  }
  .p {
    font-size: 12px;
    color: #768191;
  }
}

.slide-two {
  height: 409px;
  // margin: 36px 0 128px;
  background: url(../assets/buyClass.png) no-repeat center;
  background-size: 100% auto;
}
.slide-three {
  margin: 36px 0 128px;
  height: 420px;
  background: url(../assets/rentBuyCarBanner.png) no-repeat center;
  background-size: auto 100%;
}

/* 爆款车型任你选 */
.vehicle-list {
  width: 1250px;
  margin: 0 auto;
  background: #f7f7f8;
}
.vehicle-list ul {
  width: 100%;
}
.vehicle-list .vehicle-item {
  width: calc(33.3333333333% - 20px);
  background-color: #fff;
  margin-right: 30px;
  margin-bottom: 30px;
  float: left;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.vehicle-list .vehicle-item:nth-of-type(3n) {
  margin-right: 0;
}
.vehicle-list .vehicle-item img {
  width: 402px;
  height: 209px;
  object-fit: cover;
}
.vehicle-list .vehicle-item .vehicle-item-content {
  padding: 20px;
}
.vehicle-list .vehicle-item .vehicle-item-content h2 {
  font-size: 16px;
  color: #001024;
}
.vehicle-list .vehicle-item .vehicle-item-content .tags {
  margin: 10px 0;
}
.vehicle-list .vehicle-item .vehicle-item-content .tags span {
  display: inline-block;
  margin-right: 10px;
  padding: 4px 8px;
  background-color: #eee;
  border-radius: 3px;
  color: #364554;
}
.vehicle-list .vehicle-item .vehicle-item-content ol li {
  display: inline-block;
  margin: 5px 20px 10px 0;
}
.vehicle-list .vehicle-item .vehicle-item-content ol li span {
  display: block;
  line-height: 1.5;
}
.vehicle-list .vehicle-item .vehicle-item-content ol li span:first-of-type {
  color: #999;
}
.vehicle-list .vehicle-item .vehicle-item-content ol li span:last-of-type {
  color: #f00;
  font-size: 18px;
}
.vehicle-list .vehicle-item .vehicle-item-content .desc {
  color: #999;
  margin: 5px 0 30px;
}
.vehicle-list .vehicle-item .vehicle-item-content a {
  display: block;
  width: 100%;
  margin-top: 10px;
  background-color: #f16622;
  padding: 11px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  font-size: 14px;
  box-sizing: border-box;
}
/* 弹窗 */
.dialog-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap .dialog-mask {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap-show,
.dialog-wrap-show .dialog-mask {
  opacity: 1;
  visibility: visible;
}
.dialog-wrap .dialog-form {
  width: 456px;
  // height: 396px;
  padding: 48px 32px;
  background-color: #fff;
  border-radius: 8px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -198px;
  margin-left: -228px;
  transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
}
.dialog-wrap-show .dialog-form {
  transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
}
.dialog-wrap .dialog-form .dialog-close {
  width: 24px;
  height: 24px;
  float: right;
  margin-top: -32px;
  margin-right: -16px;
  cursor: pointer;
  position: relative;
}
.dialog-wrap .dialog-form .dialog-close::before {
  display: block;
  content: "";
  width: 20px;
  height: 2px;
  background-color: #999;
  transform: rotate(45deg);
  position: absolute;
  left: 2px;
  top: 10px;
}
.dialog-wrap .dialog-form .dialog-close::after {
  display: block;
  content: "";
  width: 20px;
  height: 2px;
  background-color: #999;
  transform: rotate(-45deg);
  position: absolute;
  left: 2px;
  top: 10px;
}
.dialog-wrap .dialog-form p {
  margin-bottom: 32px;
}
.dialog-wrap .dialog-form input {
  border-radius: 4px;
  border: 1px solid rgba(220, 222, 226, 1);
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
.dialog-wrap .dialog-form p:nth-of-type(1) input,
.dialog-wrap .dialog-form p:nth-of-type(2) input {
  width: 100%;
}
.dialog-wrap .dialog-form p:nth-of-type(3) {
  position: relative;
}
.dialog-wrap .dialog-form p:nth-of-type(3) input {
  width: 100%;
  padding-right: 120px;
}
.dialog-wrap .dialog-form p:nth-of-type(3) span {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  float: right;
  width: 120px;
  height: 100%;
  text-align: center;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  color: #f16622;
  background-color: transparent;
  border-radius: 4px;
  text-decoration: underline;
}
.dialog-wrap .dialog-form a {
  display: block;
  width: 100%;
  height: 48px;
  line-height: 48px;
  border-radius: 4px;
  text-align: center;
  background-color: #fad1bd;
  color: #fff;
  font-size: 14px;
  margin-top: 44px;
}
</style>